import React, { PureComponent } from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import { IconButton, TextField, Button, Tooltip, Zoom } from '@mui/material';
import { Map as MapIcon, Delete as DeleteIcon, Block as NoneIcon } from '@mui/icons-material';

import PageContainer from '../../common/components/Page/PageContainer';
import Tile from '../../common/components/Tile/Tile';
import './RegionDetails.css';
import TableEnhancedContainer from '../../common/components/TableEnhanced/TableEnhancedContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import AddUserDialog from './components/AddUserDialog';
import ConfirmationDialog from '../../common/components/ConfirmationDialog/ConfirmationDialog';

class RegionDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.usersTableColumnsConfig = [
      {
        name: 'Username',
        key: 'Username',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Role',
        key: 'RoleName',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Is default user',
        key: 'DefaultUser',
        type: 'boolean',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Actions',
        key: 'Actions',
        type: 'markup',
        markup: (el, col, elIndex, colIndex) => {
          return el.Editable ? (
            <PermissionsCheck permission={PermissionsEnum.EDIT_REGIONS}>
              <div>
                <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                  <IconButton
                    size="large"
                    key={1}
                    style={{}}
                    onClick={() => {
                      return props.onRemoveUserCallback(el);
                    }}
                    data-qa="qa-delete-button"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </PermissionsCheck>
          ) : (
            <div>
              <PermissionsCheck permission={PermissionsEnum.EDIT_REGIONS}>
                <IconButton disabled={true}>
                  <NoneIcon />
                </IconButton>
              </PermissionsCheck>
            </div>
          );
        },
        style: { width: '10rem' },
        visible: true,
        filterable: false,
        sortable: false,
      },
    ];

    this.instrumentsColumnsConfig = [
      {
        name: 'Serial number',
        key: 'SerialNumber',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Type',
        key: 'Type',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
    ];
  }

  render() {
    return (
      <PageContainer pageName="region-details">
        <ConfirmationDialog
          onClickCancel={this.props.showConfirmDialog.cancel}
          onClickMainAction={this.props.showConfirmDialog.action}
          open={this.props.showConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirm}
          title={this.props.showConfirmDialog.title}
          mainActionLabel={this.props.showConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showConfirmDialog.disableMainAction}
        />
        <AddUserDialog
          onClickCancel={this.props.showAddUserDialog.cancel}
          onClickMainAction={this.props.showAddUserDialog.action}
          open={this.props.showAddUserDialog.show}
          disableMainAction={this.props.showAddUserDialog.disableMainAction}
          assignableUsers={this.props.assignableUsers}
          selectedUserId={this.props.selectedUserId}
          handleSelectedUser={this.props.handleSelectedUser}
        />
        <Tile
          className="u-mb-full"
          title={`Details of region "${this.props.region.Name}"`}
          TitleIcon={MapIcon}
          helpTag="region_details-region"
        >
          <div className="u-fx u-fx-space-between u-fx-align-end u-mb-full">
            <PermissionsCheck permission={PermissionsEnum.EDIT_REGIONS}>
              <TextField
                variant="standard"
                data-qa="qa-editRegionName"
                label="Region name"
                error={this.props.updateRegionErrorText !== ''}
                helperText={this.props.updateRegionErrorText}
                style={{ width: '100%' }}
                value={this.props.region.Name}
                onChange={(event) => this.props.onChangeCallback('Name', event.target.value)}
              />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.EDIT_REGIONS} hasPermission={false}>
              <span>{this.props.region.Name}</span>
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.EDIT_REGIONS}>
              <Button
                variant="contained"
                className="u-ml-full"
                data-qa="qa-saveRegionName"
                color="primary"
                onClick={this.props.onSubmitChangeRegionName}
                disabled={this.props.updateRegionErrorText !== ''}
              >
                SAVE
              </Button>
            </PermissionsCheck>
          </div>
        </Tile>

        <Tile
          className="u-mb-full"
          title={`Users of region "${this.props.region.Name}"`}
          TitleIcon={MapIcon}
          helpTag="region_details-users"
          RightContent={
            <div>
              <PermissionsCheck permission={PermissionsEnum.EDIT_REGIONS}>
                <Button
                  variant="contained"
                  data-qa="qa-addUserToRegion"
                  className="u-ml-double"
                  color="primary"
                  onClick={() => this.props.openAddUserDialogCallback('')}
                >
                  Add user
                </Button>
              </PermissionsCheck>
            </div>
          }
        >
          <TableEnhancedContainer
            data={this.props.users}
            columns={this.usersTableColumnsConfig}
            enableHideColumns={false}
            enableActionButtons={false}
            qaTag="qa-table-users"
          />
        </Tile>

        <Tile
          title={`Instruments of region "${this.props.region.Name}"`}
          TitleIcon={MapIcon}
          helpTag="region_details-instruments"
        >
          <TableEnhancedContainer
            data={this.props.instruments}
            columns={this.instrumentsColumnsConfig}
            enableHideColumns={false}
            enableActionButtons={false}
            qaTag="qa-table-instruments"
            onClickRow={this.onClickRow}
          />
        </Tile>
      </PageContainer>
    );
  }

  onClickRow = (el) => {
    const { navigate } = this.props;
    navigate(`/instrument-details/${el.SerialNumber}`);
  };
}

export default withRouter(RegionDetails);
